import { ArrowForwardIos, RocketLaunch } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable }) => {
  const triggers = data?.triggers || [];
  const isCatchAll = data?.isCatchAll || false;
  const scheduleEnabled = data?.scheduleRules?.enabled || false;
  const scheduleRules = data?.scheduleRules?.rules || [];

  const dayNames = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];

  return (
    <div
      style={{
        backgroundColor: "#F9FDF9",
        padding: "10px 12px",
        borderRadius: "10px",
        boxShadow: "rgba(0, 0, 0, 0.08) 0px 3px 8px",
        border: isCatchAll
          ? "1.5px solid rgba(99,102,241,0.5)"
          : triggers.length > 0
          ? "1.5px solid rgba(0,201,122,0.5)"
          : "1px solid rgba(58, 186, 56, 0.25)",
        minWidth: 200,
        maxWidth: 260,
        cursor: "pointer",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
        <RocketLaunch sx={{ width: 16, height: 16, color: "#3aba38" }} />
        <span style={{ color: "#232323", fontSize: 13, fontWeight: 600 }}>
          Início do fluxo
        </span>
      </div>

      {/* Trigger info */}
      {isCatchAll ? (
        <div style={{
          background: "rgba(99,102,241,0.1)",
          borderRadius: 6,
          padding: "4px 8px",
          fontSize: 11,
          color: "#4338CA",
          fontWeight: 700,
        }}>
          ⚡ Fluxo Padrão
        </div>
      ) : triggers.length > 0 ? (
        <div>
          <div style={{ fontSize: 10, color: "#888", marginBottom: 3, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
            Ativa quando receber:
          </div>
          {triggers.slice(0, 3).map((t, i) => (
            <div key={i} style={{
              background: "rgba(0,201,122,0.08)",
              borderRadius: 4,
              padding: "2px 6px",
              fontSize: 11,
              color: "#00875A",
              marginBottom: 2,
              display: "flex",
              justifyContent: "space-between",
            }}>
              <span style={{ fontStyle: "italic" }}>"{t.text || t}"</span>
              <span style={{ opacity: 0.6, marginLeft: 4 }}>{t.type === "exact" ? "=" : "⊃"}</span>
            </div>
          ))}
          {triggers.length > 3 && (
            <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>
              +{triggers.length - 3} mais...
            </div>
          )}
        </div>
      ) : (
        <div style={{ color: "#bbb", fontSize: 10, fontStyle: "italic", marginBottom: 2 }}>
          Clique duplo para configurar gatilho
        </div>
      )}

      {/* Schedule badge */}
      {scheduleEnabled && scheduleRules.length > 0 && (
        <div style={{
          marginTop: 6,
          background: "rgba(245,158,11,0.1)",
          borderRadius: 5,
          padding: "3px 7px",
          fontSize: 10,
          color: "#B45309",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}>
          🕐 {scheduleRules.map(r => `${r.days.map(d => dayNames[d]).join(",")} ${r.startTime}–${r.endTime}`).join(" | ")}
        </div>
      )}

      {/* Hint when empty */}
      {!isCatchAll && triggers.length === 0 && !scheduleEnabled && (
        <div style={{
          marginTop: 4,
          background: "rgba(99,102,241,0.07)",
          borderRadius: 5,
          padding: "4px 8px",
          fontSize: 10,
          color: "#6366F1",
          textAlign: "center",
        }}>
          ⚡ clique 2x para configurar
        </div>
      )}

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#9a00ed",
          width: 18,
          height: 18,
          top: "50%",
          right: -11,
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{ color: "#fff", width: 10, height: 10, marginLeft: "2.9px", marginBottom: "1px", pointerEvents: "none" }}
        />
      </Handle>
    </div>
  );
});
